import { serialize, htmlToElement, getClosestByClass, requestTimeout } from '../lib/helper'; //, triggerEvent
import { currentBreakpoint } from '../lib/responsive';
import { getInstance, reload } from '../lib/component';
import { toArray } from 'lodash';
import axios from 'axios';
import RangSlider from './RangSlider';
import Quickview from './Quickview';

export default class FilterSubmit {

  constructor(el) {

    this.el = el;
    this.form = this.el.querySelector('form');
    this.route = this.el.getAttribute('data-route');
    this.routeRemove = this.el.getAttribute('data-route-remove');
    this.chosenFilterWrapper = this.el.querySelector('.choosen-filter-wrapper');
    this.activeFilterListWrapper = this.el.querySelector('.tc-active-filter-list');
    this.accordion = this.el.querySelector('.tc-accordion');
    this.onCloseScroll = this.scroll;
    this.filterListTop = document.querySelector('#filter-list-top');
    this.filterListBottom = document.querySelector('#filter-list-bottom');
    this.filterResults = document.querySelector('#filter-results');
    this.resultCountEl = [].slice.call(document.querySelectorAll('.tc-filter-result-count'));
    this.resultTitleEl = [].slice.call(document.querySelectorAll('.filter-result-title'));
    this.pageTitleEl = document.querySelector('.page-title');
    this.oldFocusedElement = null;
    this.timerMap = new Map();

    this.onFilterStatusChangeListener = this.onFilterStatusChange.bind(this);
    this.onAutocompleteInputBlurListener = this.onAutocompleteInputBlur.bind(this);
    this.onKeyDownListener = this.onKeyDown.bind(this);

    // get the right route [url, request-type]
    try {

      this.routeParams = window.routes[this.route];
      this.routeRemoveParams = window.routes[this.routeRemove];
    } catch (error) {

      throw error;
    }

    this.registerEvents();
    this.initSubmitTriggers();
    this.buildActiveFilters();
  }

  registerEvents() {

    if (this.accordion) {

      this.accordion.addEventListener('accordion-close', this.onCloseScroll.bind(this), false);
    }

    this.el.addEventListener('change', this.track.bind(this), false);
  }

  initSubmitTriggers() {

    this.submitTriggers = this.el.querySelectorAll('.tc-filter-formfield');
    this.rangeInputFilterBtns = this.el.querySelectorAll('.is-range-slider-no-touch .is-cta');

    for (let i = 0; i < this.submitTriggers.length; i++) {

      if (this.submitTriggers[i].classList.contains('has-autocomplete')) {

        this.submitTriggers[i].addEventListener('onFilterSet', this.onFilterStatusChangeListener, false);
        this.submitTriggers[i].querySelector('input:not([type="hidden"])').addEventListener('blur', this.onAutocompleteInputBlurListener, false);
        this.submitTriggers[i].addEventListener('keyup', this.onKeyDownListener, false);
      } else {

        if (this.submitTriggers[i].classList.contains('range-min-input') || this.submitTriggers[i].classList.contains('range-max-input')) {

          if (Modernizr && Modernizr.touchevents) {

            this.submitTriggers[i].addEventListener('change', this.onFilterStatusChangeListener, false);
          }
        } else {

          this.submitTriggers[i].addEventListener('change', this.onFilterStatusChangeListener, false);
        }
      }
    }

    for (let i = 0; i < this.rangeInputFilterBtns.length; i++) {

      this.rangeInputFilterBtns[i].addEventListener('click', this.onFilterStatusChangeListener, false);
    }
  }

  unsubscribeSubmitTriggers() {

    for (let i = 0; i < this.submitTriggers.length; i++) {

      if (this.submitTriggers[i].classList.contains('has-autocomplete')) {

        this.submitTriggers[i].removeEventListener('onFilterSet', this.onFilterStatusChangeListener, false);
        this.submitTriggers[i].querySelector('input').removeEventListener('blur', this.onAutocompleteInputBlurListener, false);
        this.submitTriggers[i].removeEventListener('keyup', this.onKeyDownListener, false);
      } else {

        this.submitTriggers[i].removeEventListener('change', this.onFilterStatusChangeListener, false);
      }
    }

    for (let i = 0; i < this.rangeInputFilterBtns.length; i++) {

      this.rangeInputFilterBtns[i].removeEventListener('click', this.onFilterStatusChangeListener, false);
    }
  }

  onAutocompleteInputBlur(e) {

    let el = e.target;

    if (el.tagName.toLowerCase() !== 'input') {

      el = el.querySelector('input');
    }

    let autocompleteId = el.getAttribute('data-autocomplete');
    if (autocompleteId) {

      const suggestionList = this.el.querySelector(autocompleteId);
      if (suggestionList && suggestionList.offsetParent) {

        // do nothing if the autocomplete suggestions are still open
        // this is handled when the user clicks on the suggestion
        return;
      }
    }

    if (el.value.length) {

      this.onFilterStatusChange();
    }
  }

  onKeyDown(e) {

    let el = e.target;

    if (el.tagName.toLowerCase() !== 'input') {

      el = el.querySelector('input');
    }

    if (e && e.keyCode === 13 && el.value.length) {

      this.onFilterStatusChange();
    }
  }

  scroll() {

    if (currentBreakpoint === 'xs') {

      requestTimeout(() => {

        window.scrollTo(0, this.el.offsetTop);
      }, 75);
    }

    return;
  }

  /**
   * handles the request
   */

  track(e) {
    const el = e.target;
    const multiSelectorParent = el.closest('.tc-multi-selector');
    
    if (el.matches('.input-visible-hidden')) {
      return;
    }

    switch (true) {
    default:
      break;

    case !!el.getAttribute('placeholder'):
      if (el.value) {
        window._paq = window._paq || [];
        window._paq.push([
          'trackEvent',
          'UI',
          'Filter',
          el.getAttribute('placeholder'),
          el.value
        ]);
      }
      break;

    case !!multiSelectorParent:
      if (el.id && el.checked) {
        window._paq = window._paq || [];
        window._paq.push([
          'trackEvent',
          'UI',
          'Filter',
          multiSelectorParent.querySelector('.label').getAttribute('title'),
          multiSelectorParent.querySelector('[for="' + el.id + '"]').textContent
        ]);
      }
      break;
    }
  }

  onFilterStatusChange(e) {

    const formfields = this.el.querySelectorAll('input, select');

    for (let i = 0; i < formfields.length; i++) {

      if (formfields[i].name.substring(0, 1) !== '$' && getComputedStyle(formfields[i]).display === 'none') {

        formfields[i].parentNode.removeChild(formfields[i]);
      }
    }

    if (window.tcLoader) {

      window.tcLoader.setActive();
    }

    // submit changes handler
    // @TODO validation for min/max inputs
    axios({
      method: this.routeParams[1].toLowerCase(),
      url: this.routeParams[0],
      data: serialize(this.form, true),
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(res => {

      if (window.tcLoader) {

        window.tcLoader.setInactive();
      }

      // if the response is ok, the active filters has to be rebuild
      this.handleResponse(res.data);
      this.resetFilterAreas(res.data);
      this.resetFilterResults(res.data);
      this.buildActiveFilters(res.data);
      this.setResultCount(res.data);
      this.setResultTitle(res.data);

      reload();
  
    })
    .catch(function (error) {

      if (window.tcLoader) {

        window.tcLoader.setInactive();
      }
      throw new Error(`FilterSubmit.js, can't set filter: ${error.message}`);
    });
  }

  setResultCount(data) {

    if (data.displayNumResults && this.resultCountEl.length) {

      this.resultCountEl.map(el => {

        el.innerHTML = data.displayNumResults;
      });
    }
  }

  setResultTitle(data) {

    if (data.displayTitle && this.resultTitleEl.length) {

      this.resultTitleEl.map(el => {

        el.innerHTML = data.displayTitle;
      });
    }
    if (data.pageTitle && this.pageTitleEl) {

      this.pageTitleEl.innerHTML = data.pageTitle;
    }
  }

  handleResponse(res) {

    if (res.pageUrl && window.history.pushState) {

      window.history.pushState(null, null, res.pageUrl);
    }
  }

  resetFilterAreas(data) {

    if (!data.filterListBottom || !this.filterListBottom) {

      return;
    }

    this.unsubscribeSubmitTriggers();

    if (this.filterListTop) {

      this.filterListTop.innerHTML = data.filterListTop || '';
    }

    this.filterListBottom.innerHTML = data.filterListBottom || '';

    this.initSubmitTriggers();
  }

  resetFilterResults(data) {

    if (!data.filterResult || !this.filterResults) {

      return;
    }

    this.filterResults.innerHTML = data.filterResult;
    window.responsiveImagesManager.setup(this.filterResults);
    window.taikoComponent.reloadModule(Quickview, '.tc-quickview-wrapper');
  }


  /**
   * recieves all active filters from the response
   * resets the active filter elements and binds the necessary event-listeners to the new ones
   * @param  {Object} data [description]
   */

  buildActiveFilters(data) {

    if (data) {

      if (!data.activeFilter || !this.activeFilterListWrapper) {

        return;
      }

      if (this.activeFilterEls) {

        // remove listener
        for (let i = 0; i < this.activeFilterEls.length; i++) {

          this.activeFilterEls[i].removeEventListener('click', this.activeFilterEls[i].resetFilterHandler, false);
        }
      }

      this.activeFilterEls = [];

      // remove elements
      while (this.activeFilterListWrapper.firstChild) {

        this.activeFilterListWrapper.removeChild(this.activeFilterListWrapper.firstChild);
      }

      if (data.showFilters) {

        this.chosenFilterWrapper.classList.remove('hide-filters');
      } else {

        this.chosenFilterWrapper.classList.add('hide-filters');
      }

      if (data.activeFilter.length > 0) {

        this.chosenFilterWrapper.classList.remove('has-no-filters');
      } else {

        this.chosenFilterWrapper.classList.add('has-no-filters');
      }

      for (let i = 0; i < data.activeFilter.length; i++) {

        const newActiveFilter = htmlToElement(data.activeFilter[i]);
        newActiveFilter.resetFilterHandler = this.resetFilter.bind(this, newActiveFilter);
        newActiveFilter.addEventListener('click', newActiveFilter.resetFilterHandler, false);
        this.activeFilterEls.push(newActiveFilter);
        this.activeFilterListWrapper.appendChild(newActiveFilter);
      }
    } else {

      this.activeFilterEls = toArray(document.querySelectorAll('.tc-filter-item'));

      for (let i = 0; i < this.activeFilterEls.length; i++) {

        this.activeFilterEls[i].resetFilterHandler = this.resetFilter.bind(this, this.activeFilterEls[i]);
        this.activeFilterEls[i].addEventListener('click', this.activeFilterEls[i].resetFilterHandler, false);
      }
    }
  }


  /**
   * tries to resetting the target formfields due to its type
   * @param {Node} el  the clicked element
   */

  resetFilter(el) {

    if (!el) {

      return;
    }

    if (window.tcLoader) {

      window.tcLoader.setActive();
    }

    axios({
      method: this.routeRemoveParams[1].toLowerCase(),
      url: this.routeRemoveParams[0],
      data: JSON.parse(el.getAttribute('data-filter')),
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(res => {

      if (window.tcLoader) {

        window.tcLoader.setInactive();
      }

      // if the response is ok, the active filters has to be rebuild
      this.handleResponse(res.data);
      this.resetFilterAreas(res.data);
      this.resetFilterResults(res.data);
      this.buildActiveFilters(res.data);
      this.setResultCount(res.data);
      this.setResultTitle(res.data);

      reload();
    })
    .catch(function (error) {

      if (window.tcLoader) {

        window.tcLoader.setInactive();
      }

      throw new Error(`FilterSubmit.js, can't remove filter: ${error.message}`);
    });
  }


  /**
   * [resetFilterFromRange description]
   * @param {Node} el  the target formfield to reset, which is part of a range-slider module
   * @param {Array} min the match(/_min$/)-value of the return from checking the target formfield to reset
   * @param {Array} max the match(/_max$/)-value of the return from checking the target formfield to reset
   */
  resetFilterFromRange(el, min, max) {

    try {

      const rangeSliderEl = getClosestByClass(el, 'tc-range-slider-wrapper');
      const rangeSliderInstance = getInstance(RangSlider, rangeSliderEl);
      rangeSliderInstance.resetValues(min, max);
    } catch (error) {

      throw new Error(error, 'could not reset filter', `[name="${el.getAttribute('data-target-filter')}"`);
    }
  }
}


